// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ResourceResourceType extends TrackingModel {
	public ResourceResourceTypeId: number = 0;
	public ResourceId: number = 0;
	public ResourceTypeId: number = 0;
}